var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class BarcoClickShare {
    constructor(log) {
        this.contentSharing = false;
        this.power = true; // enable so content sharing starts automatically
        this.pollCounter = 0; // After 10 polls, content is shared for 10 polls
        this.asyncHandlers = [
            {
                name: 'powerStandby',
                path: /\/operations\/standby/i,
                method: 'post',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    this.power = false;
                    this.contentSharing = false;
                    const response = {
                        status: 202,
                        message: 'Request accepted.',
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
            {
                name: 'powerWakeup',
                path: /\/operations\/wakeup/i,
                method: 'post',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    this.power = true;
                    const response = {
                        status: 202,
                        message: 'Request accepted.',
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
            {
                name: 'systemIdentity',
                path: /\/configuration\/system\/device-identity/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        articleNumber: 'R9861512US',
                        hardwareVersion: '1.0',
                        modelName: 'C3010S',
                        productName: 'CX-20',
                        serialNumber: '1863012988',
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
            {
                name: 'systemPowerGet',
                path: /\/configuration\/system\/power-management/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        powerMode: 'EcoStandby',
                        supportedPowerModes: ['EcoStandby', 'NetworkedStandby', 'DeepStandby'],
                        status: this.power ? 'On' : 'Standby',
                        supportedStatuses: ['On', 'Standby'],
                        standbyTimeout: '10',
                        supportedStandbyTimeouts: ['Infinite', '1', '5', '10', '15', '30', '45', '60'],
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
            {
                name: 'systemStatus',
                path: /\/configuration\/system\/status/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    // To test sharing, set the sharing state after 10 polls
                    if (this.power && this.pollCounter++ > 10) {
                        this.pollCounter = 0;
                        this.contentSharing = !this.contentSharing;
                    }
                    const response = {
                        errorCode: 'Ok',
                        errorMessage: '',
                        currentUptime: 846419,
                        totalUptime: 874233,
                        firstUsed: '2023-09-26T18:07:04',
                        inUse: true,
                        sharing: this.contentSharing,
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
            {
                name: 'systemUpdates',
                path: /\/configuration\/system\/updates\/current/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        date: '2023-09-26T22:15:02',
                        version: '02.16.00.0017',
                    };
                    return this.makeResponse(req, JSON.stringify(response));
                }),
            },
        ];
    }
    makeResponse(request, result) {
        return {
            status: 200,
            headers: {
                'okhttp-response-source': 'NETWORK 200',
                'keep-alive': 'timeout=60',
                'content-length': `'${result.length}'`,
                'cache-control': 'no-store',
                'okhttp-selected-protocol': 'http/1.1',
                'content-type': 'application/json',
                charset: 'utf-8',
            },
            data: result,
        };
    }
}
BarcoClickShare.emulatorType = 'httpRequestEmulator';
BarcoClickShare.key = '-Ng02YzgYCE4nnm8wpiV';
